import classNames from "classnames";
import styles from "./style.module.scss";
import CustomButton from "shared/components/common/customButton";
import { Icons } from "assets";
import { useEffect, useState } from "react";
import { GetOrganizationsStatsService } from "shared/services/dashboard";
import SekeletonLoader from "shared/loaders/skeleton";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";

const EvaluationCard = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [organizations, setOrganizations] = useState<string[]>([]);

  const handleGetNewOrganizations = () => {
    setLoading(true);
    GetOrganizationsStatsService()
      .then(({ data }) => {
        setOrganizations(data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetNewOrganizations();
  }, []);

  return (
    <div
      className={classNames("flex flex-col gap-3", styles.evalCardContainer)}
    >
      <h1>Requests Pending Evaluation by CGP</h1>
      <div className={classNames(styles.tableWrapper)}>
        <table className="table" style={{ minWidth: "800px", margin: "0px" }}>
          <thead>
            <tr style={{ height: "44px" }}>
              <th
                className={classNames(styles.tableHead)}
                style={{ width: "33.333%" }}
              >
                Organization Name
              </th>
              <th
                className={classNames(styles.tableHead)}
                style={{ textAlign: "center", width: "33.333%" }}
              >
                No. of Requested Evaluations
              </th>
              <th
                className={classNames(styles.tableHead)}
                style={{ textAlign: "center", width: "33.333%" }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <>
                {Array.from(Array(2).keys())?.map((_, index) => {
                  return <TableRowLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {organizations?.map((org: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td className={classNames(styles.tableContentLabel)}>
                        <div className={classNames("flex items-center gap-2")}>
                          <div className={classNames(styles.avtContainer)}>
                            <label>
                              {org?.name?.split(" ")?.[0]?.[0]}
                              {org?.name?.split(" ")?.[1]?.[0]}
                            </label>
                          </div>
                          <h2>{org?.name}</h2>
                        </div>
                      </td>
                      <td className={classNames(styles.tableContentLabel)}>
                        <div
                          className={classNames(
                            "flex items-center justify-center"
                          )}
                        >
                          <div className={classNames(styles.countContainer)}>
                            <label>
                              {org?.requests_count} Evaluation
                              {org?.requests_count === 1 ? "" : "s"}
                            </label>
                          </div>
                        </div>
                      </td>
                      <td className={classNames(styles.tableContentLabel)}>
                        <div
                          className={classNames(
                            "flex items-center justify-center"
                          )}
                        >
                          <CustomButton
                            title="View"
                            Icon={Icons.Eye}
                            IconDirction="right"
                            containerStyle={classNames(styles.actionButton)}
                            iconStyle={classNames(styles.actionIcon)}
                            onClick={() => {
                              navigate(
                                routeConstant.singleOrganizationRequestedEvaluation.path.replace(
                                  ":id",
                                  org?.id
                                )
                              );
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TableRowLoader = () => {
  return (
    <tr>
      <td className={classNames(styles.tableContentLabel)}>
        <div className={classNames("flex items-center gap-2")}>
          <SekeletonLoader className={classNames(styles.avtLoader)} />
          <SekeletonLoader className={classNames(styles.avtTitleLoader)} />
        </div>
      </td>
      <td className={classNames(styles.tableContentLabel)}>
        <div className={classNames("flex items-center justify-center")}>
          <SekeletonLoader className={classNames(styles.countLoader)} />
        </div>
      </td>
      <td className={classNames(styles.tableContentLabel)}>
        <div className={classNames("flex items-center justify-center")}>
          <SekeletonLoader className={classNames(styles.actionBtnLoader)} />
        </div>
      </td>
    </tr>
  );
};

export default EvaluationCard;
